module.exports = __webpack_public_path__ + "videoThumbnail.2af3ff2e0570a297986d28f46bda79ec.svg";